import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductQuantityBreakPricing, {
    ProductQuantityBreakPricingStyles,
} from "@insite/content-library/Components/ProductQuantityBreakPricing";
import * as React from "react";
import { css } from "styled-components";

/* Store Custom Code - Start */
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import StoreProductQtyBreakPricing, {
    StoreProductQtyBreakPricingStyles,
} from "@store/Components/Store/StoreProductQtyBreakPricing";
import { useProductSettings } from "@store/Hooks/useSettings/useSettings";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
/* Store Custom Code - End */

type Props = WidgetProps & HasProduct;

export interface ProductDetailsQuantityBreakPricingStyles {
    quantityBreakPricing?: ProductQuantityBreakPricingStyles;
    // Store Custom Code
    storeQtyBreakPricing?: StoreProductQtyBreakPricingStyles;
}

export const quantityBreakPricingStyles: ProductDetailsQuantityBreakPricingStyles = {
    quantityBreakPricing: {
        viewLink: {
            css: css`
                margin: 8px 0;
            `,
        },
    },
    // Store Custom Code
    storeQtyBreakPricing: {
        breakpriceWrapper: {
            css: css`
                width: auto;
            `,
        },
        breakPriceRightText: {
            css: css`
                ${({ theme }) =>
                    breakpointValuesMediaQueries(
                        theme,
                        [{ values: ["auto", null, "30px", null, null], properties: ["margin-left"] }],
                        mediaOptions.min,
                    )}
            `,
        },
    },
};

const styles = quantityBreakPricingStyles;

const ProductDetailsQuantityBreakPricing: React.FC<Props> = ({ product }) => {
    const { canSeePrices } = useProductSettings(); // Store Custom Code

    if (!product || !canSeePrices /* Store Custom Code */) {
        return null;
    }

    /* Store Custom Code - Start */
    return <StoreProductQtyBreakPricing extendedStyles={styles.storeQtyBreakPricing} />;
    /* Store Custom Code - End */
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsQuantityBreakPricing),
    definition: {
        displayName: "Quantity Break Pricing",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
